import type { ReactNode } from 'react';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconCheckCircle } from '#src/atoms/icons/system/iconCheckCircle.ts';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineXS } from '#src/atoms/typography/index.tsx';

type Props = {
  title: ReactNode;
  children: ReactNode;
};
export const CompletedStep = ({ title, children }: Props) => (
  <Vertical gap={0.5}>
    <Horizontal>
      <FontAwesomeIcon icon={iconCheckCircle} color="var(--c-onBase-success)" />
      <HeadlineXS as="h6" color="var(--c-white)">
        {title}
      </HeadlineXS>
    </Horizontal>
    {children}
  </Vertical>
);
